import React from 'react';

export const MiniPlayerVideo = () => {
  return <div>Video</div>;
};
